import { HTMLInputTypeAttribute } from 'react';
import { SVGIcon } from '../SVGIcons';

interface IInput {
  hasSearchIcon?: boolean;
  warning?: boolean;
  className?: string;
  placeholder?: string;
  name?: string;
  style?: string;
  value?: string | number | readonly string[];
  accept?: string;
  multiple?: boolean;
  maxLength?: number;
  type?: HTMLInputTypeAttribute;
  // onChange: ChangeEventHandler<HTMLInputElement>
  onChange?: (e: any) => void;
}

const Input: React.FC<IInput> = ({
  hasSearchIcon = false,
  className = '',
  placeholder,
  name,
  style,
  onChange,
  value,
  accept,
  maxLength,
  warning = false,
  type = 'text',
  multiple = false,
}) => {
  return (
    <div
      className={`mr-4 flex h-12 rounded-md border-2 ${
        warning
          ? 'border-erro-bordocaulequente50 ring-erro-bordocaulequente50'
          : 'border-neutra3-cinzaquente70'
      } bg-white ${style}`}
    >
      {hasSearchIcon && (
        <SVGIcon
          name="search"
          color="#45433A"
          size="small"
          strokeColor="black"
          strokeWidth={0.5}
          className="absolute left-2 top-[5px]"
        />
      )}
      <input
        name={name}
        type={type}
        accept={accept}
        className={`w-full border-none bg-transparent py-1 pl-2 pr-4 text-sm placeholder:text-neutra3-cinzaquente50 
          ${!warning ? 'focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-neutra3-cinzaquente50' : 'focus-visible:ring-erro-bordocaulequente50'} ${className}`}
        placeholder={placeholder}
        onChange={onChange}
        value={value}
        multiple={multiple}
        maxLength={maxLength}
      />
      {/* <label htmlFor={indentifier}></label> */}
    </div>
  );
};

export default Input;
